import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import handleOpenWhatsApp from 'services/whatsappService';

const ANCHOR_IMAGE = 'https://files.tnonetwork.com/users/talent/lilianafernandes.jpg';

const AreYouReady = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <Box>
      <Box component={Typography} sx={{ fontWeight: 700 }} variant={'h2'} gutterBottom align={'center'} marginBottom={'2rem'}>
        ¿Listo para conectar con quienes buscan vivir en equilibrio?
      </Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 600 }}
        variant={'h4'}
        gutterBottom
        align={'center'}
        marginBottom={'2rem'}
        color="textSecondary"
      >
        Forma parte de Vivir en Equilibrio y acompaña a una audiencia activa que prioriza salud, constancia y bienestar integral. Hagamos que tu marca sea parte de su transformación.
      </Box>

      <Grid container spacing={4}>
        <Grid item container alignItems={'center'} xs={12} md={6}>
          <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
            <Box marginBottom={2}>
              <Typography variant="h5" color="textPrimary" sx={{ fontWeight: 700 }}>
                Patrocinio, segmentos temáticos y UGC wellness: tu marca en el programa de equilibrio integral de TNO Network.
              </Typography>
            </Box>
            <Box marginBottom={3}>
              <Typography variant="body1" component="p" color="textSecondary" sx={{ fontWeight: 400 }}>
                Vivir en Equilibrio, con Liliana Fernandes al frente. Bienestar que transforma.
              </Typography>
            </Box>
            <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretched', sm: 'flex-start' }}>
              <Button
                component={'a'}
                variant="contained"
                color="primary"
                size="large"
                fullWidth={!isMd}
                onClick={handleOpenWhatsApp}
                target={'_blank'}
              >
                Patrocinar Vivir en Equilibrio
              </Button>
              <Box marginTop={{ xs: 2, sm: 0 }} marginLeft={{ sm: 2 }} width={{ xs: '100%', md: 'auto' }}>
                <Button
                  component={'a'}
                  href={'https://www.tnonetwork.com'}
                  variant="outlined"
                  color="primary"
                  size="large"
                  fullWidth={!isMd}
                >
                  TNO Network
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box height={'100%'} width={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Box height={'100%'} width={'100%'} maxHeight={600}>
              <Box
                component="img"
                src={ANCHOR_IMAGE}
                alt="Liliana Fernandes - Vivir en Equilibrio, TNO"
                sx={{ width: '100%', height: 'auto', maxHeight: 600, objectFit: 'contain', borderRadius: 2 }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Vivir en Equilibrio: Bienestar que transforma.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
